import { RouteComponetParam } from '../../tools/public'
import {
  StatementText,
  GetLocalStorage,
  decodeAuthToken,
  getSupplierId,
  getUserId,
  SetLocalStorage,
  isResponseCodeSuccess,
} from '../../tools/util'
import { userRouter } from '../../route'
import { useReducer, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useTypedSelector, history } from '../../redux/store'
import { Form } from 'antd'
import { addRouterAction } from '../../modules/routerModules'
import { useLocation } from 'react-router-dom'
import {
  GET_HOMEDATA,
  GET_HOME_MATTER,
  GET_HOME_SUPPLIER_ORDERCOUNT,
  GET_ORDER_PLATFORM_LIST,
  GET_WORKBENCH_PERMISSION,
  GET_WORKBENCH_MATTER,
  GET_WORKBENCH_CUSTOMER_ORDER,
  GET_WORKBENCH_INQUIRY,
  GET_WORKBENCH_XH_ORDER,
  type WorkBenchProductDTO,
  type WorkBenchCustomerOrderDTO,
  type WorkBenchInquiryDTO,
  type WorkBenchXhOrderDTO,
} from '../../api/CommonApi'
import type { PermissionList } from '../../api/CommonApi'
import { GET_INQUIRY_TABCOUNTS, InquiryTabCountVO } from '../../api/inquiry'
import { getExpressListAction, setEnterpriseInfo } from '../../modules/homedata'
import {
  GET_ACCOUNT_PAYMENT_COUNT,
  GET_ORDER_STATE_COUNT,
} from '../../api/orderManage'
import {
  getAreaOptionsAction,
  getPlatformListAction,
  getConnectedProjectCodeAction,
} from '../../modules/goodsdetailmodules/reducer'
import { GET_LAST_NOTICE, ReturnDetail } from '../../api/AnnouncementApi'
import { usePermissionStore } from '@/stores/permission'

const ACTION_TYPE = {
  INIT: 'init',
  INITDATA: 'init_data',
  CONPANYDATA: 'conpany_data',
  INITAUDITDATA: 'init_audit_data',
  SET_SPINNING: 'set_spinning',
  SET_TEXT: 'set_text',
  CHANGE_MODE: 'change_mode',
  MENU_NUMBER: 'menu_number',
  MENU_MATTER: 'menu_matter',
  MENU_SUPPLIERCOUNT: 'menu_suppliercount',
  SET_UPDATE_NOTICE: 'set_update_notice',
  SET_PAYMENT_COUNT: 'set_payment_count',
  SET_NEWEST_INVOICE: 'set_newest_invoice',
  SET_INQUIRY_COUNT: 'set_inquiry_count',
  SET_WORKBENCH_PERMISSION: 'set_workbench_permission',
  SET_WORKBENCH_MATTER: 'set_workbench_matter',
  SET_WORKBENCH_CUSTOMER_ORDER: 'set_workbench_customer_order',
  SET_WORKBENCH_INQUIRY: 'set_workbench_inquiry',
  SET_WORKBENCH_XH_ORDER: 'set_workbench_xh_order',
  SET_WORKBENCH_MATTER_LOADING: 'set_workbench_matter_loading',
  SET_WORKBENCH_CUSTOMER_ORDER_LOADING: 'set_workbench_customer_order_loading',
  SET_WORKBENCH_INQUIRY_LOADING: 'set_workbench_inquiry_loading',
  SET_WORKBENCH_XH_ORDER_LOADING: 'set_workbench_xh_order_loading',
}
interface nowpagesparam {
  tempId?: string // 暂存商品 id
  childId?: string // 子商品 id
  supplierId?: string
  // 选中的tree层级
}
interface menuItem {
  routeGoods: RouteComponetParam[]
  routeBrand: RouteComponetParam[]
  routeCateattr: RouteComponetParam[]
  routeStatistic: RouteComponetParam[]
  routeSystem: RouteComponetParam[]
  routeData: RouteComponetParam[]
  routeRelation: RouteComponetParam[]
  routeOrders: RouteComponetParam[]
}
interface numberItem {
  allProductNum: number
  incrementProductNum: number
  stockProductDeleteNum: number
  stockProductRemainingNum: number
  stockProductRemovedNum: number
}
interface auditnumberItem {
  incrementAssess: number // 增量审核数量
  stockAssess: number // 存量审核数量
  updateAssess: number // 修改审核数量
}

interface conpanyItem {
  corporate: string // 法定代表人
  date: string // 成立日期
  enterpriseName: string // 企业名称
  id: string // 供应商ID
  licenseUrl: string // 营业执照
  regAddress: string // 注册地址
  regCapital: string // 注册资本
  regStatus: string // 经营状态
  uscc: string // 统一社会信用代码
  cooperateType: string // 合作形式
}

interface menuNumItem {
  resSetData: any[]
  brandManagement: boolean
}
interface Matter {
  addProductCount: string // 累计新增物料
  examineProductCount: string // 审核中物料
  saleProductCount: string // 在售物料
  waitCount: number // 待履约
  processCount: number // 履约中
  completeCount: number // 已完成
  acceptedCount: number // 待验收
  dropShippingCount: number // 待发货
}
interface SupplierCount {
  inProgressCount: number
  returnCount: number
  toConfirmCount: number
  waitCount: number
}
interface PaymentCount {
  payableOrdersTotal: number // 可付款订单
  openInvoiceCount: number // 电商供应商可录入发票数
  rejectInvoiceCount: number // 被驳回发票总计
  supplierOrderOpenInvoiceCount: number // 供应商可录入发票
}
interface InquiryCount {
  unfinishedCount: number // 未完结数量（待接单+待报价）
  finishedCount: number // 已完结数量
  totalCount: number // 总数量
}
interface State {
  menuListData: menuItem
  deadlin: number
  data: numberItem
  auditdata: auditnumberItem
  spinning: boolean
  textData: string
  mode: boolean
  conpanyInfo: conpanyItem
  menuNumInfo: menuNumItem
  matterInfo: Matter
  supplierCount: SupplierCount
  paymentCount: PaymentCount
  newestInvoice: ReturnDetail
  inquiryCount: InquiryCount
  workbenchPermissionList: PermissionList[]
  workbenchMatter: WorkBenchProductDTO | null
  workbenchCustomerOrder: WorkBenchCustomerOrderDTO | null
  workbenchInquiry: WorkBenchInquiryDTO | null
  workbenchXhOrder: WorkBenchXhOrderDTO | null
  workbenchMatterLoading: boolean
  workbenchCustomerOrderLoading: boolean
  workbenchInquiryLoading: boolean
  workbenchXhOrderLoading: boolean
}

const defaultState: State = {
  menuListData: {
    routeGoods: [],
    routeBrand: [],
    routeCateattr: [],
    routeStatistic: [],
    routeSystem: [],
    routeData: [],
    routeRelation: [],
    routeOrders: [],
  },
  deadlin: 0,
  data: {
    allProductNum: 0,
    incrementProductNum: 0,
    stockProductDeleteNum: 0,
    stockProductRemainingNum: 0,
    stockProductRemovedNum: 0,
  },
  auditdata: {
    incrementAssess: 0,
    stockAssess: 0,
    updateAssess: 0,
  },
  spinning: true,
  textData: StatementText(),
  mode: false,
  conpanyInfo: {
    corporate: '',
    date: '',
    enterpriseName: '',
    id: '',
    licenseUrl: '',
    regAddress: '',
    regCapital: '',
    regStatus: '',
    uscc: '',
    cooperateType: '',
  },
  menuNumInfo: {
    resSetData: [],
    brandManagement: false,
  },
  matterInfo: {
    addProductCount: '',
    examineProductCount: '',
    saleProductCount: '',
    waitCount: 0,
    processCount: 0,
    completeCount: 0,
    acceptedCount: 0, // 待验收
    dropShippingCount: 0, // 待发货
  },
  supplierCount: {
    inProgressCount: 0,
    returnCount: 0,
    toConfirmCount: 0,
    waitCount: 0,
  },
  paymentCount: {
    payableOrdersTotal: 0,
    openInvoiceCount: 0,
    rejectInvoiceCount: 0,
    supplierOrderOpenInvoiceCount: 0,
  },
  inquiryCount: {
    unfinishedCount: 0,
    finishedCount: 0,
    totalCount: 0,
  },
  newestInvoice: {
    content: '',
    createMan: '',
    createTime: 0,
    id: '',
    img: '',
    rangType: 0,
    state: 0,
    title: '',
    codes: '',
    sendMsg: false,
    fileList: '',
  },
  workbenchPermissionList: [],
  workbenchMatter: null,
  workbenchCustomerOrder: null,
  workbenchInquiry: null,
  workbenchXhOrder: null,
  workbenchMatterLoading: false,
  workbenchCustomerOrderLoading: false,
  workbenchInquiryLoading: false,
  workbenchXhOrderLoading: false,
}
const reducer = (
  state: State,
  action: { type: string; value?: any },
): State => {
  const arr = { ...state }
  switch (action.type) {
    case ACTION_TYPE.INIT:
      arr.menuListData = action.value
      return arr
    case ACTION_TYPE.INITDATA:
      arr.data = action.value
      return arr
    case ACTION_TYPE.INITAUDITDATA:
      arr.auditdata = action.value
      return arr
    case ACTION_TYPE.SET_SPINNING:
      arr.spinning = action.value
      return arr
    case ACTION_TYPE.SET_TEXT:
      arr.textData = action.value
      return arr
    case ACTION_TYPE.CHANGE_MODE:
      arr.mode = action.value
      return arr
    case ACTION_TYPE.CONPANYDATA:
      arr.conpanyInfo = action.value
      return arr
    case ACTION_TYPE.MENU_NUMBER:
      arr.menuListData.routeData = action.value
      return arr
    case ACTION_TYPE.MENU_MATTER:
      arr.matterInfo = action.value
      return arr
    case ACTION_TYPE.MENU_SUPPLIERCOUNT:
      arr.supplierCount = action.value
      return arr
    case ACTION_TYPE.SET_PAYMENT_COUNT:
      arr.paymentCount = action.value
      return arr
    case ACTION_TYPE.SET_NEWEST_INVOICE:
      arr.newestInvoice = action.value
      return arr
    case ACTION_TYPE.SET_INQUIRY_COUNT:
      arr.inquiryCount = action.value
      return arr
    case ACTION_TYPE.SET_WORKBENCH_PERMISSION:
      arr.workbenchPermissionList = action.value
      return arr
    case ACTION_TYPE.SET_WORKBENCH_MATTER:
      arr.workbenchMatter = action.value
      return arr
    case ACTION_TYPE.SET_WORKBENCH_CUSTOMER_ORDER:
      arr.workbenchCustomerOrder = action.value
      return arr
    case ACTION_TYPE.SET_WORKBENCH_INQUIRY:
      arr.workbenchInquiry = action.value
      return arr
    case ACTION_TYPE.SET_WORKBENCH_XH_ORDER:
      arr.workbenchXhOrder = action.value
      return arr
    case ACTION_TYPE.SET_WORKBENCH_MATTER_LOADING:
      arr.workbenchMatterLoading = action.value
      return arr
    case ACTION_TYPE.SET_WORKBENCH_CUSTOMER_ORDER_LOADING:
      arr.workbenchCustomerOrderLoading = action.value
      return arr
    case ACTION_TYPE.SET_WORKBENCH_INQUIRY_LOADING:
      arr.workbenchInquiryLoading = action.value
      return arr
    case ACTION_TYPE.SET_WORKBENCH_XH_ORDER_LOADING:
      arr.workbenchXhOrderLoading = action.value
      return arr
    default:
      return state
  }
}

const setConpanyAction = (param: conpanyItem) => ({
  type: ACTION_TYPE.CONPANYDATA,
  value: param,
})

// 工作台物料信息
const setMatterAction = (param: Matter) => ({
  type: ACTION_TYPE.MENU_MATTER,
  value: param,
})

const setSpinningAction = (param: boolean) => ({
  type: ACTION_TYPE.SET_SPINNING,
  value: param,
})

const setModeAction = (param: boolean) => ({
  type: ACTION_TYPE.CHANGE_MODE,
  value: param,
})

const setSupplierCountAction = (param: SupplierCount) => ({
  type: ACTION_TYPE.MENU_SUPPLIERCOUNT,
  value: param,
})

const setPaymentCount = (param: PaymentCount) => ({
  type: ACTION_TYPE.SET_PAYMENT_COUNT,
  value: param,
})

const setNewestInvoice = (param: ReturnDetail) => ({
  type: ACTION_TYPE.SET_NEWEST_INVOICE,
  value: param,
})

const setInquiryCount = (param: InquiryCount) => ({
  type: ACTION_TYPE.SET_INQUIRY_COUNT,
  value: param,
})

const setWorkbenchPermission = (param: PermissionList[]) => ({
  type: ACTION_TYPE.SET_WORKBENCH_PERMISSION,
  value: param,
})

const setWorkbenchMatter = (param: WorkBenchProductDTO | null) => ({
  type: ACTION_TYPE.SET_WORKBENCH_MATTER,
  value: param,
})

const setWorkbenchCustomerOrder = (
  param: WorkBenchCustomerOrderDTO | null,
) => ({
  type: ACTION_TYPE.SET_WORKBENCH_CUSTOMER_ORDER,
  value: param,
})

const setWorkbenchInquiry = (param: WorkBenchInquiryDTO | null) => ({
  type: ACTION_TYPE.SET_WORKBENCH_INQUIRY,
  value: param,
})

const setWorkbenchXhOrder = (param: WorkBenchXhOrderDTO | null) => ({
  type: ACTION_TYPE.SET_WORKBENCH_XH_ORDER,
  value: param,
})

const setWorkbenchMatterLoading = (param: boolean) => ({
  type: ACTION_TYPE.SET_WORKBENCH_MATTER_LOADING,
  value: param,
})

const setWorkbenchCustomerOrderLoading = (param: boolean) => ({
  type: ACTION_TYPE.SET_WORKBENCH_CUSTOMER_ORDER_LOADING,
  value: param,
})

const setWorkbenchInquiryLoading = (param: boolean) => ({
  type: ACTION_TYPE.SET_WORKBENCH_INQUIRY_LOADING,
  value: param,
})

const setWorkbenchXhOrderLoading = (param: boolean) => ({
  type: ACTION_TYPE.SET_WORKBENCH_XH_ORDER_LOADING,
  value: param,
})

const useHome = () => {
  const supRoute = userRouter[1].url
  const [pageState, dispatchpage] = useReducer(reducer, defaultState)
  const dispatch = useDispatch()
  const { tabsData } = useTypedSelector((state) => state.authtoken)
  const {
    menuListData,
    data,
    spinning,
    textData,
    auditdata,
    mode,
    conpanyInfo,
    matterInfo,
    supplierCount,
    paymentCount,
    newestInvoice,
    inquiryCount,
    workbenchPermissionList,
    workbenchMatter,
    workbenchCustomerOrder,
    workbenchInquiry,
    workbenchXhOrder,
    workbenchMatterLoading,
    workbenchCustomerOrderLoading,
    workbenchInquiryLoading,
    workbenchXhOrderLoading,
  } = pageState
  const {
    routeGoods,
    routeBrand,
    routeCateattr,
    routeOrders,
    routeStatistic,
    routeSystem,
    routeData,
    routeRelation,
  } = menuListData
  const location = useLocation<nowpagesparam>()
  const { state } = location
  const [form] = Form.useForm()
  const permissionList = usePermissionStore((state) => state.permissionList)
  useEffect(() => {
    // 获取最新一条公告
    getNewestNotice()
    initData()
    // eslint-disable-next-line
  }, [])

  // 获取看板权限
  const getWorkbenchPermission = async () => {
    try {
      const res = await GET_WORKBENCH_PERMISSION({
        supplierId: getSupplierId(),
      })
      if (isResponseCodeSuccess(res.code)) {
        const permissions = res.data || []
        dispatchpage(setWorkbenchPermission(permissions))
        // 根据权限列表并行调用对应的接口
        await getWorkbenchData(permissions)
      }
    } catch (error) {
      console.error('获取看板权限失败:', error)
    }
  }

  // 根据权限列表获取对应的看板数据
  const getWorkbenchData = async (permissions: PermissionList[]) => {
    const supplierId = getSupplierId()
    const promises: Promise<void>[] = []

    // 我的物料
    if (permissions.includes('我的物料')) {
      promises.push(
        (async () => {
          try {
            dispatchpage(setWorkbenchMatterLoading(true))
            const res = await GET_WORKBENCH_MATTER({ supplierId })
            if (isResponseCodeSuccess(res.code)) {
              dispatchpage(setWorkbenchMatter(res.data))
            }
          } catch (error) {
            console.error('获取我的物料数据失败:', error)
            dispatchpage(setWorkbenchMatter(null))
          } finally {
            dispatchpage(setWorkbenchMatterLoading(false))
          }
        })(),
      )
    }

    // 电供客户订单
    if (permissions.includes('电供客户订单')) {
      promises.push(
        (async () => {
          try {
            dispatchpage(setWorkbenchCustomerOrderLoading(true))
            const res = await GET_WORKBENCH_CUSTOMER_ORDER({ supplierId })
            if (isResponseCodeSuccess(res.code)) {
              dispatchpage(setWorkbenchCustomerOrder(res.data))
            }
          } catch (error) {
            console.error('获取电供客户订单数据失败:', error)
            dispatchpage(setWorkbenchCustomerOrder(null))
          } finally {
            dispatchpage(setWorkbenchCustomerOrderLoading(false))
          }
        })(),
      )
    }

    // 我的询价单
    if (permissions.includes('我的询价单')) {
      promises.push(
        (async () => {
          try {
            dispatchpage(setWorkbenchInquiryLoading(true))
            const res = await GET_WORKBENCH_INQUIRY({ supplierId })
            if (isResponseCodeSuccess(res.code)) {
              dispatchpage(setWorkbenchInquiry(res.data))
            }
          } catch (error) {
            console.error('获取我的询价单数据失败:', error)
            dispatchpage(setWorkbenchInquiry(null))
          } finally {
            dispatchpage(setWorkbenchInquiryLoading(false))
          }
        })(),
      )
    }

    // 咸亨订单
    if (permissions.includes('咸亨订单')) {
      promises.push(
        (async () => {
          try {
            dispatchpage(setWorkbenchXhOrderLoading(true))
            const res = await GET_WORKBENCH_XH_ORDER({ supplierId })
            if (isResponseCodeSuccess(res.code)) {
              dispatchpage(setWorkbenchXhOrder(res.data))
            }
          } catch (error) {
            console.error('获取咸亨订单数据失败:', error)
            dispatchpage(setWorkbenchXhOrder(null))
          } finally {
            dispatchpage(setWorkbenchXhOrderLoading(false))
          }
        })(),
      )
    }

    // 并行执行所有请求
    await Promise.all(promises)
  }
  // 初始化数据
  const initData = async () => {
    // 从本地读取角色信息
    const token = GetLocalStorage('SRM_TOKEN')
    if (token) {
      // 获取看板权限
      await getWorkbenchPermission()
      if (state) {
        gethomepage(state.supplierId)
      } else {
        gethomepage()
      }
      dispatch(getPlatformListAction())
      dispatch(getAreaOptionsAction())
      dispatch(getConnectedProjectCodeAction())
      dispatch(getExpressListAction())
      getPlatform()
      getMatter()
      const info = decodeAuthToken(token)
      // 审核经理 审核员 显示审核统计数量模块
      const flag =
        info.role === 'SOURCE_ASSESS_MAN' ||
        info.role === 'SOURCE_ASSESS_MANAGER'
          ? true
          : false
      dispatchpage(setModeAction(flag))
    }
  }

  // 获取数据
  const gethomepage = async (supplierId?: string) => {
    dispatchpage(setSpinningAction(true))
    const resData = await GET_HOMEDATA({
      supplierId: supplierId ? supplierId : getSupplierId(),
    })
    if (resData.code === 0) {
      const setConpantData = {
        corporate: resData.data.corporate,
        date: resData.data.date,
        enterpriseName: resData.data.enterpriseName,
        id: resData.data.id,
        licenseUrl: resData.data.licenseUrl,
        regAddress: resData.data.regAddress,
        regCapital: resData.data.regCapital,
        regStatus: resData.data.regStatus,
        uscc: resData.data.uscc,
        cooperateType:
          resData.data.cooperateType === '3'
            ? '电商供应商、供应商'
            : resData.data.cooperateType === '2'
              ? '电商供应商'
              : '供应商',
      }
      dispatchpage(setConpanyAction(setConpantData))
      // 更新全局的首页数据
      dispatch(setEnterpriseInfo(resData.data))
      SetLocalStorage('HOME_DATA', resData.data)
      SetLocalStorage('ENTERPRISE_NAME', resData.data.enterpriseName)
    }
  }
  // 路由跳转
  const onClick = (item: RouteComponetParam) => {
    let url = supRoute + item.url
    let BtnState: string[] = []
    if (item.url === '/addgoods') {
      // 新增物料
      BtnState = ['Edit', 'Add']
    }
    // 限制开启待我审核模块
    if (item.keyName === 'waitaudit') {
      // !!! 用来筛选是否需要新增页签
      const tab = tabsData.filter((t) => t.keyName === item.keyName)
      if (tab.length >= 1) {
        // 复制 路由模块 生成 新的url key 并动态添加一个路由 keyName必须和原模块相同
        const random = Math.random().toString(36).substr(2)
        const action = addRouterAction({
          keyName: item.key, // 指定唯一 默认标识 不可更改
          title: `${item.title} [${tab.length}]`,
          component: item.component,
          exact: true,
          key: `${item.key + random}`,
          url: `${item.url + random}`,
        })
        dispatch(action)
        url = supRoute + item.url + random
      }
    }

    history.replace({
      pathname: url,
      state: {
        init: 'initdata',
        BtnState: BtnState,
        // 审核来源：新增物料
        auditSource: item.url === '/addgoods' ? 'SRM_SECOND_ADD' : undefined,
      },
    })
  }

  // 刷新
  const onRefresh = () => {
    getMatter()
    // 刷新看板数据
    if (workbenchPermissionList.length > 0) {
      getWorkbenchData(workbenchPermissionList)
    }
  }

  // 获取工作台物料情况
  const getMatter = async () => {
    dispatchpage(setSpinningAction(true))
    // 物料统计
    const res1 = await GET_HOME_MATTER({
      supplierId: getSupplierId(),
    })
    // 订单统计(电商供应商订单)
    const res2 = await GET_ORDER_STATE_COUNT({
      supplierId: getSupplierId(),
    })
    if (res1.code === 0 && res2.code === 0) {
      const active = {
        addProductCount: res1.data.addProductCount,
        examineProductCount: res1.data.examineProductCount,
        saleProductCount: res1.data.saleProductCount,
        processCount: res2.data.processCount,
        waitCount: res2.data.waitCount,
        completeCount: res2.data.completeCount,
        acceptedCount: res2.data.acceptedCount, // 待验收
        dropShippingCount: res2.data.dropShippingCount, // 待发货
      }
      dispatchpage(setSpinningAction(false))
      dispatchpage(setMatterAction(active))
    }
    // 供应商信息
    const res3 = await GET_HOME_SUPPLIER_ORDERCOUNT({
      supplierId: getSupplierId(),
    })
    if (res3.code === 0) {
      dispatchpage(setSupplierCountAction(res3.data))
    }
    // 开票付款
    const res4 = await GET_ACCOUNT_PAYMENT_COUNT({
      supplierId: getSupplierId(),
    })
    if (res4.code === 0) {
      dispatchpage(setPaymentCount(res4.data))
    }
    // 询价单统计
    const res5 = await GET_INQUIRY_TABCOUNTS({
      supplierId: getSupplierId(),
      userId: getUserId(),
      completionStatus: 3, // 全部
    })
    if (isResponseCodeSuccess(res5.code)) {
      dispatchpage(
        setInquiryCount({
          unfinishedCount: res5.data.unfinishedCount,
          finishedCount: res5.data.finishedCount,
          totalCount: res5.data.totalCount,
        }),
      )
    }
  }
  const onJump = (url: string) => {
    history.replace({
      pathname: `/srm/${url}`,
    })
  }

  // 获取下单平台列表
  const getPlatform = async () => {
    const res = await GET_ORDER_PLATFORM_LIST()
    if (isResponseCodeSuccess(res.code)) {
      const resData = (res.data || []).map((item: any) => ({
        name: item.platformName,
        code: item.platformCode,
        id: item.code,
      }))
      SetLocalStorage('PLATFORM', resData)
    }
  }

  // 获取最新一条公告
  const getNewestNotice = async () => {
    const res = await GET_LAST_NOTICE({
      rangType: GetLocalStorage('COOPERATETYPE'),
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatchpage(setNewestInvoice(res.data))
    }
  }

  // 跳转详情
  const jumpToNoticeDetail = () => {
    history.replace({
      pathname: `${supRoute}/xhNoticeDetail`,
      state: {
        id: newestInvoice.id,
      },
    })
  }

  return {
    routeGoods,
    routeBrand,
    routeCateattr,
    routeOrders,
    routeStatistic,
    routeSystem,
    routeData,
    routeRelation,
    data,
    spinning,
    textData,
    form,
    auditdata,
    mode,
    onClick,
    onRefresh,
    conpanyInfo,
    matterInfo,
    onJump,
    supplierCount,
    paymentCount,
    newestInvoice,
    jumpToNoticeDetail,
    permissionList,
    inquiryCount,
    workbenchPermissionList,
    workbenchMatter,
    workbenchCustomerOrder,
    workbenchInquiry,
    workbenchXhOrder,
    workbenchMatterLoading,
    workbenchCustomerOrderLoading,
    workbenchInquiryLoading,
    workbenchXhOrderLoading,
  }
}
export default useHome
import { RouteComponetParam } from '../../tools/public'
import {
  StatementText,
  GetLocalStorage,
  decodeAuthToken,
  getSupplierId,
  getUserId,
  SetLocalStorage,
  isResponseCodeSuccess,
} from '../../tools/util'
import { userRouter } from '../../route'
import { useReducer, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useTypedSelector, history } from '../../redux/store'
import { Form } from 'antd'
import { addRouterAction } from '../../modules/routerModules'
import { useLocation } from 'react-router-dom'
import {
  GET_HOMEDATA,
  GET_HOME_MATTER,
  GET_HOME_SUPPLIER_ORDERCOUNT,
  GET_ORDER_PLATFORM_LIST,
  GET_WORKBENCH_PERMISSION,
  GET_WORKBENCH_MATTER,
  GET_WORKBENCH_CUSTOMER_ORDER,
  GET_WORKBENCH_INQUIRY,
  GET_WORKBENCH_XH_ORDER,
  type WorkBenchProductDTO,
  type WorkBenchCustomerOrderDTO,
  type WorkBenchInquiryDTO,
  type WorkBenchXhOrderDTO,
} from '../../api/CommonApi'
import type { PermissionList } from '../../api/CommonApi'
import { GET_INQUIRY_TABCOUNTS, InquiryTabCountVO } from '../../api/inquiry'
import { getExpressListAction, setEnterpriseInfo } from '../../modules/homedata'
import {
  GET_ACCOUNT_PAYMENT_COUNT,
  GET_ORDER_STATE_COUNT,
} from '../../api/orderManage'
import {
  getAreaOptionsAction,
  getPlatformListAction,
  getConnectedProjectCodeAction,
} from '../../modules/goodsdetailmodules/reducer'
import { GET_LAST_NOTICE, ReturnDetail } from '../../api/AnnouncementApi'
import { usePermissionStore } from '@/stores/permission'

const ACTION_TYPE = {
  INIT: 'init',
  INITDATA: 'init_data',
  CONPANYDATA: 'conpany_data',
  INITAUDITDATA: 'init_audit_data',
  SET_SPINNING: 'set_spinning',
  SET_TEXT: 'set_text',
  CHANGE_MODE: 'change_mode',
  MENU_NUMBER: 'menu_number',
  MENU_MATTER: 'menu_matter',
  MENU_SUPPLIERCOUNT: 'menu_suppliercount',
  SET_UPDATE_NOTICE: 'set_update_notice',
  SET_PAYMENT_COUNT: 'set_payment_count',
  SET_NEWEST_INVOICE: 'set_newest_invoice',
  SET_INQUIRY_COUNT: 'set_inquiry_count',
  SET_WORKBENCH_PERMISSION: 'set_workbench_permission',
  SET_WORKBENCH_MATTER: 'set_workbench_matter',
  SET_WORKBENCH_CUSTOMER_ORDER: 'set_workbench_customer_order',
  SET_WORKBENCH_INQUIRY: 'set_workbench_inquiry',
  SET_WORKBENCH_XH_ORDER: 'set_workbench_xh_order',
  SET_WORKBENCH_MATTER_LOADING: 'set_workbench_matter_loading',
  SET_WORKBENCH_CUSTOMER_ORDER_LOADING: 'set_workbench_customer_order_loading',
  SET_WORKBENCH_INQUIRY_LOADING: 'set_workbench_inquiry_loading',
  SET_WORKBENCH_XH_ORDER_LOADING: 'set_workbench_xh_order_loading',
}
interface nowpagesparam {
  tempId?: string // 暂存商品 id
  childId?: string // 子商品 id
  supplierId?: string
  // 选中的tree层级
}
interface menuItem {
  routeGoods: RouteComponetParam[]
  routeBrand: RouteComponetParam[]
  routeCateattr: RouteComponetParam[]
  routeStatistic: RouteComponetParam[]
  routeSystem: RouteComponetParam[]
  routeData: RouteComponetParam[]
  routeRelation: RouteComponetParam[]
  routeOrders: RouteComponetParam[]
}
interface numberItem {
  allProductNum: number
  incrementProductNum: number
  stockProductDeleteNum: number
  stockProductRemainingNum: number
  stockProductRemovedNum: number
}
interface auditnumberItem {
  incrementAssess: number // 增量审核数量
  stockAssess: number // 存量审核数量
  updateAssess: number // 修改审核数量
}

interface conpanyItem {
  corporate: string // 法定代表人
  date: string // 成立日期
  enterpriseName: string // 企业名称
  id: string // 供应商ID
  licenseUrl: string // 营业执照
  regAddress: string // 注册地址
  regCapital: string // 注册资本
  regStatus: string // 经营状态
  uscc: string // 统一社会信用代码
  cooperateType: string // 合作形式
}

interface menuNumItem {
  resSetData: any[]
  brandManagement: boolean
}
interface Matter {
  addProductCount: string // 累计新增物料
  examineProductCount: string // 审核中物料
  saleProductCount: string // 在售物料
  waitCount: number // 待履约
  processCount: number // 履约中
  completeCount: number // 已完成
  acceptedCount: number // 待验收
  dropShippingCount: number // 待发货
}
interface SupplierCount {
  inProgressCount: number
  returnCount: number
  toConfirmCount: number
  waitCount: number
}
interface PaymentCount {
  payableOrdersTotal: number // 可付款订单
  openInvoiceCount: number // 电商供应商可录入发票数
  rejectInvoiceCount: number // 被驳回发票总计
  supplierOrderOpenInvoiceCount: number // 供应商可录入发票
}
interface InquiryCount {
  unfinishedCount: number // 未完结数量（待接单+待报价）
  finishedCount: number // 已完结数量
  totalCount: number // 总数量
}
interface State {
  menuListData: menuItem
  deadlin: number
  data: numberItem
  auditdata: auditnumberItem
  spinning: boolean
  textData: string
  mode: boolean
  conpanyInfo: conpanyItem
  menuNumInfo: menuNumItem
  matterInfo: Matter
  supplierCount: SupplierCount
  paymentCount: PaymentCount
  newestInvoice: ReturnDetail
  inquiryCount: InquiryCount
  workbenchPermissionList: PermissionList[]
  workbenchMatter: WorkBenchProductDTO | null
  workbenchCustomerOrder: WorkBenchCustomerOrderDTO | null
  workbenchInquiry: WorkBenchInquiryDTO | null
  workbenchXhOrder: WorkBenchXhOrderDTO | null
  workbenchMatterLoading: boolean
  workbenchCustomerOrderLoading: boolean
  workbenchInquiryLoading: boolean
  workbenchXhOrderLoading: boolean
}

const defaultState: State = {
  menuListData: {
    routeGoods: [],
    routeBrand: [],
    routeCateattr: [],
    routeStatistic: [],
    routeSystem: [],
    routeData: [],
    routeRelation: [],
    routeOrders: [],
  },
  deadlin: 0,
  data: {
    allProductNum: 0,
    incrementProductNum: 0,
    stockProductDeleteNum: 0,
    stockProductRemainingNum: 0,
    stockProductRemovedNum: 0,
  },
  auditdata: {
    incrementAssess: 0,
    stockAssess: 0,
    updateAssess: 0,
  },
  spinning: true,
  textData: StatementText(),
  mode: false,
  conpanyInfo: {
    corporate: '',
    date: '',
    enterpriseName: '',
    id: '',
    licenseUrl: '',
    regAddress: '',
    regCapital: '',
    regStatus: '',
    uscc: '',
    cooperateType: '',
  },
  menuNumInfo: {
    resSetData: [],
    brandManagement: false,
  },
  matterInfo: {
    addProductCount: '',
    examineProductCount: '',
    saleProductCount: '',
    waitCount: 0,
    processCount: 0,
    completeCount: 0,
    acceptedCount: 0, // 待验收
    dropShippingCount: 0, // 待发货
  },
  supplierCount: {
    inProgressCount: 0,
    returnCount: 0,
    toConfirmCount: 0,
    waitCount: 0,
  },
  paymentCount: {
    payableOrdersTotal: 0,
    openInvoiceCount: 0,
    rejectInvoiceCount: 0,
    supplierOrderOpenInvoiceCount: 0,
  },
  inquiryCount: {
    unfinishedCount: 0,
    finishedCount: 0,
    totalCount: 0,
  },
  newestInvoice: {
    content: '',
    createMan: '',
    createTime: 0,
    id: '',
    img: '',
    rangType: 0,
    state: 0,
    title: '',
    codes: '',
    sendMsg: false,
    fileList: '',
  },
  workbenchPermissionList: [],
  workbenchMatter: null,
  workbenchCustomerOrder: null,
  workbenchInquiry: null,
  workbenchXhOrder: null,
  workbenchMatterLoading: false,
  workbenchCustomerOrderLoading: false,
  workbenchInquiryLoading: false,
  workbenchXhOrderLoading: false,
}
const reducer = (
  state: State,
  action: { type: string; value?: any },
): State => {
  const arr = { ...state }
  switch (action.type) {
    case ACTION_TYPE.INIT:
      arr.menuListData = action.value
      return arr
    case ACTION_TYPE.INITDATA:
      arr.data = action.value
      return arr
    case ACTION_TYPE.INITAUDITDATA:
      arr.auditdata = action.value
      return arr
    case ACTION_TYPE.SET_SPINNING:
      arr.spinning = action.value
      return arr
    case ACTION_TYPE.SET_TEXT:
      arr.textData = action.value
      return arr
    case ACTION_TYPE.CHANGE_MODE:
      arr.mode = action.value
      return arr
    case ACTION_TYPE.CONPANYDATA:
      arr.conpanyInfo = action.value
      return arr
    case ACTION_TYPE.MENU_NUMBER:
      arr.menuListData.routeData = action.value
      return arr
    case ACTION_TYPE.MENU_MATTER:
      arr.matterInfo = action.value
      return arr
    case ACTION_TYPE.MENU_SUPPLIERCOUNT:
      arr.supplierCount = action.value
      return arr
    case ACTION_TYPE.SET_PAYMENT_COUNT:
      arr.paymentCount = action.value
      return arr
    case ACTION_TYPE.SET_NEWEST_INVOICE:
      arr.newestInvoice = action.value
      return arr
    case ACTION_TYPE.SET_INQUIRY_COUNT:
      arr.inquiryCount = action.value
      return arr
    case ACTION_TYPE.SET_WORKBENCH_PERMISSION:
      arr.workbenchPermissionList = action.value
      return arr
    case ACTION_TYPE.SET_WORKBENCH_MATTER:
      arr.workbenchMatter = action.value
      return arr
    case ACTION_TYPE.SET_WORKBENCH_CUSTOMER_ORDER:
      arr.workbenchCustomerOrder = action.value
      return arr
    case ACTION_TYPE.SET_WORKBENCH_INQUIRY:
      arr.workbenchInquiry = action.value
      return arr
    case ACTION_TYPE.SET_WORKBENCH_XH_ORDER:
      arr.workbenchXhOrder = action.value
      return arr
    case ACTION_TYPE.SET_WORKBENCH_MATTER_LOADING:
      arr.workbenchMatterLoading = action.value
      return arr
    case ACTION_TYPE.SET_WORKBENCH_CUSTOMER_ORDER_LOADING:
      arr.workbenchCustomerOrderLoading = action.value
      return arr
    case ACTION_TYPE.SET_WORKBENCH_INQUIRY_LOADING:
      arr.workbenchInquiryLoading = action.value
      return arr
    case ACTION_TYPE.SET_WORKBENCH_XH_ORDER_LOADING:
      arr.workbenchXhOrderLoading = action.value
      return arr
    default:
      return state
  }
}

const setConpanyAction = (param: conpanyItem) => ({
  type: ACTION_TYPE.CONPANYDATA,
  value: param,
})

// 工作台物料信息
const setMatterAction = (param: Matter) => ({
  type: ACTION_TYPE.MENU_MATTER,
  value: param,
})

const setSpinningAction = (param: boolean) => ({
  type: ACTION_TYPE.SET_SPINNING,
  value: param,
})

const setModeAction = (param: boolean) => ({
  type: ACTION_TYPE.CHANGE_MODE,
  value: param,
})

const setSupplierCountAction = (param: SupplierCount) => ({
  type: ACTION_TYPE.MENU_SUPPLIERCOUNT,
  value: param,
})

const setPaymentCount = (param: PaymentCount) => ({
  type: ACTION_TYPE.SET_PAYMENT_COUNT,
  value: param,
})

const setNewestInvoice = (param: ReturnDetail) => ({
  type: ACTION_TYPE.SET_NEWEST_INVOICE,
  value: param,
})

const setInquiryCount = (param: InquiryCount) => ({
  type: ACTION_TYPE.SET_INQUIRY_COUNT,
  value: param,
})

const setWorkbenchPermission = (param: PermissionList[]) => ({
  type: ACTION_TYPE.SET_WORKBENCH_PERMISSION,
  value: param,
})

const setWorkbenchMatter = (param: WorkBenchProductDTO | null) => ({
  type: ACTION_TYPE.SET_WORKBENCH_MATTER,
  value: param,
})

const setWorkbenchCustomerOrder = (
  param: WorkBenchCustomerOrderDTO | null,
) => ({
  type: ACTION_TYPE.SET_WORKBENCH_CUSTOMER_ORDER,
  value: param,
})

const setWorkbenchInquiry = (param: WorkBenchInquiryDTO | null) => ({
  type: ACTION_TYPE.SET_WORKBENCH_INQUIRY,
  value: param,
})

const setWorkbenchXhOrder = (param: WorkBenchXhOrderDTO | null) => ({
  type: ACTION_TYPE.SET_WORKBENCH_XH_ORDER,
  value: param,
})

const setWorkbenchMatterLoading = (param: boolean) => ({
  type: ACTION_TYPE.SET_WORKBENCH_MATTER_LOADING,
  value: param,
})

const setWorkbenchCustomerOrderLoading = (param: boolean) => ({
  type: ACTION_TYPE.SET_WORKBENCH_CUSTOMER_ORDER_LOADING,
  value: param,
})

const setWorkbenchInquiryLoading = (param: boolean) => ({
  type: ACTION_TYPE.SET_WORKBENCH_INQUIRY_LOADING,
  value: param,
})

const setWorkbenchXhOrderLoading = (param: boolean) => ({
  type: ACTION_TYPE.SET_WORKBENCH_XH_ORDER_LOADING,
  value: param,
})

const useHome = () => {
  const supRoute = userRouter[1].url
  const [pageState, dispatchpage] = useReducer(reducer, defaultState)
  const dispatch = useDispatch()
  const { tabsData } = useTypedSelector((state) => state.authtoken)
  const {
    menuListData,
    data,
    spinning,
    textData,
    auditdata,
    mode,
    conpanyInfo,
    matterInfo,
    supplierCount,
    paymentCount,
    newestInvoice,
    inquiryCount,
    workbenchPermissionList,
    workbenchMatter,
    workbenchCustomerOrder,
    workbenchInquiry,
    workbenchXhOrder,
    workbenchMatterLoading,
    workbenchCustomerOrderLoading,
    workbenchInquiryLoading,
    workbenchXhOrderLoading,
  } = pageState
  const {
    routeGoods,
    routeBrand,
    routeCateattr,
    routeOrders,
    routeStatistic,
    routeSystem,
    routeData,
    routeRelation,
  } = menuListData
  const location = useLocation<nowpagesparam>()
  const { state } = location
  const [form] = Form.useForm()
  const permissionList = usePermissionStore((state) => state.permissionList)
  useEffect(() => {
    // 获取最新一条公告
    getNewestNotice()
    initData()
    // eslint-disable-next-line
  }, [])

  // 获取看板权限
  const getWorkbenchPermission = async () => {
    try {
      const res = await GET_WORKBENCH_PERMISSION({
        supplierId: getSupplierId(),
      })
      if (isResponseCodeSuccess(res.code)) {
        const permissions = res.data || []
        dispatchpage(setWorkbenchPermission(permissions))
        // 根据权限列表并行调用对应的接口
        await getWorkbenchData(permissions)
      }
    } catch (error) {
      console.error('获取看板权限失败:', error)
    }
  }

  // 根据权限列表获取对应的看板数据
  const getWorkbenchData = async (permissions: PermissionList[]) => {
    const supplierId = getSupplierId()
    const promises: Promise<void>[] = []

    // 我的物料
    if (permissions.includes('我的物料')) {
      promises.push(
        (async () => {
          try {
            dispatchpage(setWorkbenchMatterLoading(true))
            const res = await GET_WORKBENCH_MATTER({ supplierId })
            if (isResponseCodeSuccess(res.code)) {
              dispatchpage(setWorkbenchMatter(res.data))
            }
          } catch (error) {
            console.error('获取我的物料数据失败:', error)
            dispatchpage(setWorkbenchMatter(null))
          } finally {
            dispatchpage(setWorkbenchMatterLoading(false))
          }
        })(),
      )
    }

    // 电供客户订单
    if (permissions.includes('电供客户订单')) {
      promises.push(
        (async () => {
          try {
            dispatchpage(setWorkbenchCustomerOrderLoading(true))
            const res = await GET_WORKBENCH_CUSTOMER_ORDER({ supplierId })
            if (isResponseCodeSuccess(res.code)) {
              dispatchpage(setWorkbenchCustomerOrder(res.data))
            }
          } catch (error) {
            console.error('获取电供客户订单数据失败:', error)
            dispatchpage(setWorkbenchCustomerOrder(null))
          } finally {
            dispatchpage(setWorkbenchCustomerOrderLoading(false))
          }
        })(),
      )
    }

    // 我的询价单
    if (permissions.includes('我的询价单')) {
      promises.push(
        (async () => {
          try {
            dispatchpage(setWorkbenchInquiryLoading(true))
            const res = await GET_WORKBENCH_INQUIRY({ supplierId })
            if (isResponseCodeSuccess(res.code)) {
              dispatchpage(setWorkbenchInquiry(res.data))
            }
          } catch (error) {
            console.error('获取我的询价单数据失败:', error)
            dispatchpage(setWorkbenchInquiry(null))
          } finally {
            dispatchpage(setWorkbenchInquiryLoading(false))
          }
        })(),
      )
    }

    // 咸亨订单
    if (permissions.includes('咸亨订单')) {
      promises.push(
        (async () => {
          try {
            dispatchpage(setWorkbenchXhOrderLoading(true))
            const res = await GET_WORKBENCH_XH_ORDER({ supplierId })
            if (isResponseCodeSuccess(res.code)) {
              dispatchpage(setWorkbenchXhOrder(res.data))
            }
          } catch (error) {
            console.error('获取咸亨订单数据失败:', error)
            dispatchpage(setWorkbenchXhOrder(null))
          } finally {
            dispatchpage(setWorkbenchXhOrderLoading(false))
          }
        })(),
      )
    }

    // 并行执行所有请求
    await Promise.all(promises)
  }
  // 初始化数据
  const initData = async () => {
    // 从本地读取角色信息
    const token = GetLocalStorage('SRM_TOKEN')
    if (token) {
      // 获取看板权限
      await getWorkbenchPermission()
      if (state) {
        gethomepage(state.supplierId)
      } else {
        gethomepage()
      }
      dispatch(getPlatformListAction())
      dispatch(getAreaOptionsAction())
      dispatch(getConnectedProjectCodeAction())
      dispatch(getExpressListAction())
      getPlatform()
      getMatter()
      const info = decodeAuthToken(token)
      // 审核经理 审核员 显示审核统计数量模块
      const flag =
        info.role === 'SOURCE_ASSESS_MAN' ||
        info.role === 'SOURCE_ASSESS_MANAGER'
          ? true
          : false
      dispatchpage(setModeAction(flag))
    }
  }

  // 获取数据
  const gethomepage = async (supplierId?: string) => {
    dispatchpage(setSpinningAction(true))
    const resData = await GET_HOMEDATA({
      supplierId: supplierId ? supplierId : getSupplierId(),
    })
    if (resData.code === 0) {
      const setConpantData = {
        corporate: resData.data.corporate,
        date: resData.data.date,
        enterpriseName: resData.data.enterpriseName,
        id: resData.data.id,
        licenseUrl: resData.data.licenseUrl,
        regAddress: resData.data.regAddress,
        regCapital: resData.data.regCapital,
        regStatus: resData.data.regStatus,
        uscc: resData.data.uscc,
        cooperateType:
          resData.data.cooperateType === '3'
            ? '电商供应商、供应商'
            : resData.data.cooperateType === '2'
              ? '电商供应商'
              : '供应商',
      }
      dispatchpage(setConpanyAction(setConpantData))
      // 更新全局的首页数据
      dispatch(setEnterpriseInfo(resData.data))
      SetLocalStorage('HOME_DATA', resData.data)
      SetLocalStorage('ENTERPRISE_NAME', resData.data.enterpriseName)
    }
  }
  // 路由跳转
  const onClick = (item: RouteComponetParam) => {
    let url = supRoute + item.url
    let BtnState: string[] = []
    if (item.url === '/addgoods') {
      // 新增物料
      BtnState = ['Edit', 'Add']
    }
    // 限制开启待我审核模块
    if (item.keyName === 'waitaudit') {
      // !!! 用来筛选是否需要新增页签
      const tab = tabsData.filter((t) => t.keyName === item.keyName)
      if (tab.length >= 1) {
        // 复制 路由模块 生成 新的url key 并动态添加一个路由 keyName必须和原模块相同
        const random = Math.random().toString(36).substr(2)
        const action = addRouterAction({
          keyName: item.key, // 指定唯一 默认标识 不可更改
          title: `${item.title} [${tab.length}]`,
          component: item.component,
          exact: true,
          key: `${item.key + random}`,
          url: `${item.url + random}`,
        })
        dispatch(action)
        url = supRoute + item.url + random
      }
    }

    history.replace({
      pathname: url,
      state: {
        init: 'initdata',
        BtnState: BtnState,
        // 审核来源：新增物料
        auditSource: item.url === '/addgoods' ? 'SRM_SECOND_ADD' : undefined,
      },
    })
  }

  // 刷新
  const onRefresh = () => {
    getMatter()
    // 刷新看板数据
    if (workbenchPermissionList.length > 0) {
      getWorkbenchData(workbenchPermissionList)
    }
  }

  // 获取工作台物料情况
  const getMatter = async () => {
    dispatchpage(setSpinningAction(true))
    // 物料统计
    const res1 = await GET_HOME_MATTER({
      supplierId: getSupplierId(),
    })
    // 订单统计(电商供应商订单)
    const res2 = await GET_ORDER_STATE_COUNT({
      supplierId: getSupplierId(),
    })
    if (res1.code === 0 && res2.code === 0) {
      const active = {
        addProductCount: res1.data.addProductCount,
        examineProductCount: res1.data.examineProductCount,
        saleProductCount: res1.data.saleProductCount,
        processCount: res2.data.processCount,
        waitCount: res2.data.waitCount,
        completeCount: res2.data.completeCount,
        acceptedCount: res2.data.acceptedCount, // 待验收
        dropShippingCount: res2.data.dropShippingCount, // 待发货
      }
      dispatchpage(setSpinningAction(false))
      dispatchpage(setMatterAction(active))
    }
    // 供应商信息
    const res3 = await GET_HOME_SUPPLIER_ORDERCOUNT({
      supplierId: getSupplierId(),
    })
    if (res3.code === 0) {
      dispatchpage(setSupplierCountAction(res3.data))
    }
    // 开票付款
    const res4 = await GET_ACCOUNT_PAYMENT_COUNT({
      supplierId: getSupplierId(),
    })
    if (res4.code === 0) {
      dispatchpage(setPaymentCount(res4.data))
    }
    // 询价单统计
    const res5 = await GET_INQUIRY_TABCOUNTS({
      supplierId: getSupplierId(),
      userId: getUserId(),
      completionStatus: 3, // 全部
    })
    if (isResponseCodeSuccess(res5.code)) {
      dispatchpage(
        setInquiryCount({
          unfinishedCount: res5.data.unfinishedCount,
          finishedCount: res5.data.finishedCount,
          totalCount: res5.data.totalCount,
        }),
      )
    }
  }
  const onJump = (url: string) => {
    history.replace({
      pathname: `/srm/${url}`,
    })
  }

  // 获取下单平台列表
  const getPlatform = async () => {
    const res = await GET_ORDER_PLATFORM_LIST()
    if (isResponseCodeSuccess(res.code)) {
      const resData = (res.data || []).map((item: any) => ({
        name: item.platformName,
        code: item.platformCode,
        id: item.code,
      }))
      SetLocalStorage('PLATFORM', resData)
    }
  }

  // 获取最新一条公告
  const getNewestNotice = async () => {
    const res = await GET_LAST_NOTICE({
      rangType: GetLocalStorage('COOPERATETYPE'),
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatchpage(setNewestInvoice(res.data))
    }
  }

  // 跳转详情
  const jumpToNoticeDetail = () => {
    history.replace({
      pathname: `${supRoute}/xhNoticeDetail`,
      state: {
        id: newestInvoice.id,
      },
    })
  }

  return {
    routeGoods,
    routeBrand,
    routeCateattr,
    routeOrders,
    routeStatistic,
    routeSystem,
    routeData,
    routeRelation,
    data,
    spinning,
    textData,
    form,
    auditdata,
    mode,
    onClick,
    onRefresh,
    conpanyInfo,
    matterInfo,
    onJump,
    supplierCount,
    paymentCount,
    newestInvoice,
    jumpToNoticeDetail,
    permissionList,
    inquiryCount,
    workbenchPermissionList,
    workbenchMatter,
    workbenchCustomerOrder,
    workbenchInquiry,
    workbenchXhOrder,
    workbenchMatterLoading,
    workbenchCustomerOrderLoading,
    workbenchInquiryLoading,
    workbenchXhOrderLoading,
  }
}
export default useHome
